import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { TdsService } from 'src/app/services/tds.service';

@Component({
  selector: 'app-tds-certificate',
  templateUrl: './tds-certificate.component.html',
  styleUrls: ['./tds-certificate.component.css']
})
export class TdsCertificateComponent implements OnInit {


  p: any = 1;
  vCode: string = "V100001";
  dataList: any[] = [];
  searchTerm:string="";

  constructor(private toastr: ToastrService, private tdsService: TdsService, private router: Router) { }


  ngOnInit() {

    this.vCode = sessionStorage.getItem("UserName");
    if (this.vCode.toLowerCase() == 'admin') this.vCode = '';
    this.getTDS();
  }
  ResetPage() {
    this.p = 1;
  }


  getTDS() {

    this.tdsService.getTDS(this.vCode).subscribe(
      res => {
        console.log(res);
        this.dataList = res.data;
      },
      error => {
        console.log(error);
      }
    );
  }

  DownloadFile(id: number) {
    this.tdsService.DownloadFile(id);
  }

  GetFileName(filePath: string) {
    return filePath.split('\\').pop();
  }


}
